import { Platform } from 'react-native'

import { getLegacyUrl } from './getLegacyUrl'

export const getAdminRoute = (path: string, lang = 'fr') => {
  const url = getLegacyUrl(path, lang)
  return Platform.OS === 'web' ? url : `/admin?url=${encodeURIComponent(url)}`
}
